import {Modal, ModalHeader, ModalBody, ModalFooter} from "../Modal";
import CustomButton from "../CustomButton";

interface Props {
  lang: string;
  modalOpen: boolean;
  setModalOpen: Function;
  t: Function;
  nrFeedbacks: number;
  originId: string;
  type: string;
}

export const RequestFeedbackModal = (props: Props) => {
  return (
    <Modal isOpen={props.modalOpen} onClose={() => props.setModalOpen(false)}>
      <ModalHeader onClose={() => props.setModalOpen(false)}>
        <div className="z-title1">{props.t("how-it-works")}</div>
      </ModalHeader>
      <ModalBody>
        {props.nrFeedbacks === 0 ? (
          <div className="z-body1 text-gray-300">
            <p>
              {props.lang === "sv"
                ? "Att be om feedback är lätt!"
                : "Requesting feedback is easy!"}
            </p>
            <p>
              {props.lang === "sv"
                ? "Gå igenom dessa tre steg:"
                : "You'll complete these 3 steps:"}
            </p>
            <ol className="list-decimal list-inside space-y-1 pl-1 mt-4">
              <li>
                {props.lang === "sv"
                  ? "Skapa feedback-frågor."
                  : "Create feedback questions."}
              </li>
              <li>
                {props.lang === "sv" ? "Välj mottagare." : "Select recipients."}
              </li>
              <li>
                {props.lang === "sv"
                  ? "Granska och skicka förfrågan."
                  : "Review and send the request."}
              </li>
            </ol>
          </div>
        ) : (
          <div className="z-body1 text-gray-300">
            <p className="mb-2">
              {props.lang === "sv"
                ? "För att säkerställa en korrekt uppföljning av dina framsteg, låt de förifyllda frågorna och mottagarna från din ursprungliga förfrågan vara oförändrade. Granska och skicka förfrågan."
                : "In order to ensure accurate progress tracking, please keep the pre-filled questions and recipients from your initial request unchanged. Review and send the request."}
            </p>
            <br />
            <p className="mb-2">
              {props.lang === "sv" ? "Följ dessa steg:" : "Follow these steps:"}
            </p>
            <ol className="list-decimal list-inside space-y-1 mt-4 pl-1">
              <li>
                {props.lang === "sv"
                  ? "Granska sammanfattningen och skicka feedbackförfrågan"
                  : "Review the summary and send the request."}
              </li>
              <li>
                {props.lang === "sv"
                  ? "Gå igenom självutvärderingen."
                  : "Go through self-assessment."}
              </li>
            </ol>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <CustomButton
          to={"/feedback/create/" + props.type + "/" + props.originId}
        >
          {props.t("get-started")}
        </CustomButton>
      </ModalFooter>
    </Modal>
  );
};
